import {useState} from 'react';
import styles from './dabaPower.module.scss';
import {DepositsTab} from './DepositsTab';
import {InvestmentsTab} from './InvestmentsTab';
import {ActiveReferrersTab} from './ActiveReferrersTab';

const SUB_TABS = [
  {key: 'deposits', label: 'Deposits'},
  {key: 'investments', label: 'Investments'},
  {key: 'active-referrers', label: 'Active Referrers'},
];

export const DabaPowerOverviewPage = () => {
  const [activeTab, setActiveTab] = useState('deposits');

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Daba Power Users</h1>
        <p className={styles.pageSubtitle}>
          Filter and view users by deposits, investments, and referrals.
        </p>
      </div>
      <div className={styles.tabsHeader}>
        <div className={styles.membersTabs}>
          {SUB_TABS.map(tab => (
            <div
              key={tab.key}
              className={`${styles.tabItem} ${
                activeTab === tab.key ? styles.activeTab : ''
              }`}
              onClick={() => setActiveTab(tab.key)}>
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.tabContent}>
        {activeTab === 'deposits' && <DepositsTab />}
        {activeTab === 'investments' && <InvestmentsTab />}
        {activeTab === 'active-referrers' && <ActiveReferrersTab />}
      </div>
    </div>
  );
};
